import { useState } from 'react';
import { Trash2, Loader2 } from 'lucide-react';


export default function ClientTable({ clients, onClientClick, onClientDeleted }) {
  const [deletingId, setDeletingId] = useState(null);
  const [confirmId, setConfirmId] = useState(null);

  const handleDelete = async (e, clientId) => {
    e.stopPropagation();
    if (confirmId !== clientId) {
      setConfirmId(clientId);
      setTimeout(() => setConfirmId(null), 3000);
      return;
    }
    setDeletingId(clientId);
    try {
      const token = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || '';
      const res = await fetch(`/api/clients/${clientId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (res.ok || res.status === 404) {
        onClientDeleted(clientId);
      } else {
        alert('Failed to delete client');
      }
    } catch {
      alert('Failed to delete client');
    } finally {
      setDeletingId(null);
      setConfirmId(null);
    }
  };

  if (!clients || clients.length === 0) {
    return (
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <p className="text-slate-500">No clients found.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 border-b">
          <tr>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">Last Name</th>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">First Name</th>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">Address</th>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">Risk State</th>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">Producer</th>
            <th className="text-left px-6 py-3 font-semibold text-slate-600">Account Executive</th>
            <th className="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr
              key={client.id}
              onClick={() => onClientClick(client.id)}
              className="border-b last:border-0 hover:bg-blue-50 transition cursor-pointer group"
            >
              <td className="px-6 py-4 font-semibold text-slate-800 group-hover:text-blue-700 transition">{client.lastName}</td>
              <td className="px-6 py-4 text-slate-600">{client.firstName}</td>
              <td className="px-6 py-4 text-slate-600">{client.address || '—'}</td>
              <td className="px-6 py-4 text-slate-600">{client.riskState || '—'}</td>
              <td className="px-6 py-4 text-slate-600">{client.producer_name || '—'}</td>
              <td className="px-6 py-4 text-slate-600">{client.account_executive_name || '—'}</td>
              <td className="px-6 py-4 text-right" onClick={e => e.stopPropagation()}>
                {deletingId === client.id ? (
                  <Loader2 size={15} className="animate-spin text-slate-400 ml-auto" />
                ) : (
                  <button
                    onClick={(e) => handleDelete(e, client.id)}
                    className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium transition ml-auto ${
                      confirmId === client.id
                        ? 'bg-red-600 text-white hover:bg-red-700'
                        : 'text-slate-400 hover:text-red-500 hover:bg-red-50 opacity-0 group-hover:opacity-100'
                    }`}
                  >
                    <Trash2 size={13} />
                    {confirmId === client.id ? 'Confirm?' : 'Delete'}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}